import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiServiceInstanceDashboard } from '../apiUtils';

export const templatesGetList = createAsyncThunk(
  'templatesGetList',
  async (payload: { batchId: number | string }) => {
    const res = await apiServiceInstanceDashboard.post(
      'projectDahboard/getList/',
      payload,
    );
    return res.data?.value || [];
  },
);

export const templatesGetMetricList = createAsyncThunk(
  'templatesGetMetricList',
  async (payload: { batchId: number | string; dashboardId: number }) => {
    const res = await apiServiceInstanceDashboard.post(
      'projectDahboard/getMetricList/',
      payload,
    );
    return res.data?.value || [];
  },
);

export const templatesGetData = createAsyncThunk(
  'templatesGetData',
  async (payload: {
    batchId: number | string;
    dashboardId: number;
    dashboardMetricId: number;
  }) => {
    const res = await apiServiceInstanceDashboard.post(
      'projectDahboard/getData/',
      payload,
    );
    return res.data?.value || [];
  },
);

export const updateReportData = async (payload: {
  batchId: number | string;
  editType: string;
  updateId: number;
  dataObj: any;
}) => {
  try {
    const res = await apiServiceInstanceDashboard.put(
      'projectDahboard/getMetricList/',
      payload,
    );
    return res;
  } catch (err) {
    console.error('updateReportData failed', err);
    return '';
  }
};

export const createApproval = async (payload: {
  batchId: number | string;
  dashboardId: number;
  metricId?: number | null;
  // per-field approval (Detailed Analysis): the field's edit-type + row id
  fieldType?: string | null;
  fieldId?: number | null;
  status: 'approved' | 'rejected';
  approvedBy: string;
  comment?: string;
}) => {
  try {
    const res = await apiServiceInstanceDashboard.post(
      'projectDahboard/approval/',
      payload,
    );
    return res;
  } catch (err) {
    console.error('createApproval failed', err);
    return '';
  }
};

export const getApprovalList = async (payload: {
  batchId: number | string;
  dashboardId: number;
  metricId?: number | null;
  fieldType?: string | null;
  fieldId?: number | null;
}) => {
  try {
    const res = await apiServiceInstanceDashboard.post(
      'projectDahboard/approval/list/',
      payload,
    );
    return res.data?.value || [];
  } catch (err) {
    console.error('getApprovalList failed', err);
    return [];
  }
};

// Latest approval status for every field of a Detailed Analysis attribute.
export const getFieldApprovalStatuses = async (payload: {
  batchId: number | string;
  dashboardId: number;
  metricId?: number | null;
}) => {
  try {
    const res = await apiServiceInstanceDashboard.post(
      'projectDahboard/approval/fields/',
      payload,
    );
    return res.data?.value || [];
  } catch (err) {
    console.error('getFieldApprovalStatuses failed', err);
    return [];
  }
};

export const getApprovalSummary = async (payload: {
  batchId: number | string;
}) => {
  try {
    const res = await apiServiceInstanceDashboard.post(
      'projectDahboard/approval/summary/',
      payload,
    );
    return res.data?.value || [];
  } catch (err) {
    console.error('getApprovalSummary failed', err);
    return [];
  }
};

export const deleteMetricData = async (payload: {
  batchId: number | string;
  deleteId: number;
  // 'survey_dashboard_metric' (stage) | 'survey_dashboard_metric_detail' (attribute)
  deleteType: string;
}) => {
  try {
    const res = await apiServiceInstanceDashboard.delete(
      'projectDahboard/getMetricList/',
      { data: payload },
    );
    return res;
  } catch (err) {
    console.error('deleteMetricData failed', err);
    return '';
  }
};
